define(["require", "exports", "tslib", "mobx", "../domain/FWpPrStatusDomain", "../../store"], function (require, exports, tslib_1, mobx_1, FWpPrStatusDomain_1, store_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FWpPrApproval = void 0;
    class FWpPrApproval {
        constructor(pr) {
            Object.defineProperty(this, "pr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "statusWatcher", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "statusPreWatcher", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "cancellableStates", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: [
                    FWpPrStatusDomain_1.FWpPrStatusDomain.Submitted
                ]
            });
            Object.defineProperty(this, "SubmissionDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "IsSubmissionEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CanUserCaptureApprovalComment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CancelDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "IsCancelEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ReverseCancellationDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "IsReverseCancellationEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.pr = pr;
            this.evaluateStatus();
            this.statusWatcher = (0, mobx_1.observe)(this.pr, "Status", x => {
                this.evaluateStatus();
            });
            this.statusPreWatcher = (0, mobx_1.observe)(this.pr, "StatusPrev", x => {
                this.evaluateStatus();
            });
        }
        evaluateStatus() {
            this.deriveSubmissionWorksState();
            this.deriveCancelWorksState();
            this.deriveReverseCancelWorksState();
        }
        get ActiveStatus() {
            if (this.pr.StatusReq && !isNaN(this.pr.StatusReq)) {
                return this.pr.StatusReq;
            }
            else {
                return this.pr.Status;
            }
        }
        submit() {
            switch (this.pr.Status) {
                case FWpPrStatusDomain_1.FWpPrStatusDomain.Due:
                    const props = {
                        title: "Are you sure?",
                        msg: "Once submitted you cannot change your report. Please check your details entered. Do you still wish to submit?",
                        enableYes: true,
                        yesLabel: "Submit",
                        enableNo: false,
                        enableCancel: true
                    };
                    store_1.StoreManager.Instance.modalStore.createYesNoCancelModal(props).then(res => {
                        if (res === store_1.ModalResponse.Yes) {
                            this.setStatus(FWpPrStatusDomain_1.FWpPrStatusDomain.Submitted);
                        }
                    });
                    break;
                case FWpPrStatusDomain_1.FWpPrStatusDomain.Submitted:
                    throw new Error("Can not promote a Progress Report that is in a submitted state");
                default:
                    throw new Error("Unknown Works Status");
            }
            this.evaluateStatus();
        }
        cancelSubmission() {
            if (this.pr.Status == FWpPrStatusDomain_1.FWpPrStatusDomain.Submitted) {
                this.setStatus(FWpPrStatusDomain_1.FWpPrStatusDomain.Due);
            }
            else {
                throw new Error(`A Progress Report with a status of ${this.pr.Status} can not be cancelled.`);
            }
            this.evaluateStatus();
        }
        reverseCancellation() {
            this.evaluateStatus();
        }
        isCancellable(statusOfInterest) {
            return this.cancellableStates.indexOf(statusOfInterest) > -1;
        }
        deriveSubmissionWorksState() {
            this.SubmissionDesc = "Submit";
            if (this.pr.FWorksProject.IsUserPriviledgedToEdit) {
                switch (this.pr.Status) {
                    case FWpPrStatusDomain_1.FWpPrStatusDomain.Due:
                        this.SubmissionDesc = "Submit Progress Report";
                        this.IsSubmissionEnabled = true;
                        this.CanUserCaptureApprovalComment = true;
                        break;
                    case FWpPrStatusDomain_1.FWpPrStatusDomain.Submitted:
                        this.SubmissionDesc = "Progress Report Submitted";
                        this.CanUserCaptureApprovalComment = false;
                        this.IsSubmissionEnabled = false;
                        break;
                    default:
                        throw new Error("Unknown Progress Report Status");
                }
            }
            else {
                this.IsSubmissionEnabled = false;
                this.CanUserCaptureApprovalComment = false;
            }
        }
        deriveCancelWorksState() {
            this.CancelDesc = "Reset";
            if (this.pr.FWorksProject && this.pr.FWorksProject.IsUserPriviledgedToEdit) {
                switch (this.pr.Status) {
                    case FWpPrStatusDomain_1.FWpPrStatusDomain.Due:
                        this.IsCancelEnabled = false;
                        break;
                    case FWpPrStatusDomain_1.FWpPrStatusDomain.Submitted:
                        this.IsCancelEnabled = true;
                        break;
                    default:
                        this.IsCancelEnabled = false;
                }
            }
            else {
                this.IsCancelEnabled = false;
            }
        }
        deriveReverseCancelWorksState() {
            this.ReverseCancellationDesc = "Reverse Cancellation";
            this.IsReverseCancellationEnabled = false;
        }
        restoreToOriginalStatus() {
            this.pr.StatusReq = NaN;
            this.evaluateStatus();
        }
        setStatus(status) {
            this.pr.StatusReq = status;
        }
    }
    exports.FWpPrApproval = FWpPrApproval;
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrApproval.prototype, "SubmissionDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrApproval.prototype, "IsSubmissionEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrApproval.prototype, "CanUserCaptureApprovalComment", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrApproval.prototype, "CancelDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrApproval.prototype, "IsCancelEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrApproval.prototype, "ReverseCancellationDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrApproval.prototype, "IsReverseCancellationEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWpPrApproval.prototype, "ActiveStatus", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpPrApproval.prototype, "deriveSubmissionWorksState", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpPrApproval.prototype, "deriveCancelWorksState", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpPrApproval.prototype, "deriveReverseCancelWorksState", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpPrApproval.prototype, "restoreToOriginalStatus", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpPrApproval.prototype, "setStatus", null);
});
